/**
 * API Base URL from environment variables
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000';

/**
 * API Endpoints
 */
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    USER_PROFILE: '/auth/user/profile',
    ADMIN_LOGIN: '/auth/admin/login',
    ADMIN_ME: '/auth/admin/me',
  },
  // Character endpoints
  CHARACTER: {
    GET_ALL: '/character/',
    GET_BY_ID: (id: string) => `/character/${id}`,
    VOTING: '/character/voting',
    VOTE: '/character/vote',
    VOTING_STATS: '/character/voting/stats',
    VOTING_TOGGLE: '/character/voting/toggle',
    VOTING_FINALIZE: '/character/voting/finalize',
  },
  // Chat endpoints
  CHAT: {
    START: '/chat/',
    SEND_MESSAGE: '/chat/query',
    GET_CHAT: '/chat/',
    GET_USER_CHATS: '/chat/my-chats',
  },
  // Payment (NOWPayments) endpoints - Standard flow: create payment → show address → poll status
  PAYMENT: {
    STATUS: '/payment/status',
    CURRENCIES: '/payment/currencies',
    MIN_AMOUNT: '/payment/min-amount',
    ESTIMATE: '/payment/estimate',
    CREATE: '/payment',
    PAYMENT_STATUS: (id: string) => `/payment/status/${id}`,
  },
} as const;

/**
 * React Query Keys
 */
export const QUERY_KEYS = {
  // Auth query keys
  AUTH: {
    USER_PROFILE: ['auth', 'user-profile'] as const,
    ADMIN_SESSION: ['auth', 'admin-session'] as const,
  },
  // Character query keys
  CHARACTER: {
    ALL: ['character', 'all'] as const,
    DETAIL: (id: string) => ['character', 'detail', id] as const,
    VOTING: ['character', 'voting'] as const,
  },
  // Chat query keys
  CHAT: {
    DETAIL: (chatId: string) => ['chat', 'detail', chatId] as const,
    USER_CHATS: ['chat', 'user-chats'] as const,
  },
  // Payment query keys
  PAYMENT: ['payment'] as const,
} as const;

/**
 * Token storage keys
 */
export const AUTH_TOKEN_KEY = 'auth_token';
export const ADMIN_TOKEN_KEY = 'admin_token';
